export default "__VITE_ASSET__CMS4GKTd__"